(function () {
  window.legacyBattleService = {
    createChallenge(data) {
      return axios.post('/api/battle/legacy/challenge.php', {
        user1TwitchId: data.fromId,
        user1TwitchDisplayName: data.fromUserName,
        user2TwitchDisplayName: data.opponent,
        user1Cards: data.cards,
        teamName: data.teamName
      });
    },
    acceptChallenge(data) {
      return axios.post('/api/battle/legacy/accept.php', {
        user1TwitchDisplayName: data.atName,
        user2TwitchDisplayName: data.fromUserName,
        user2TwitchId: data.fromId,
        user2Cards: data.cards,
        teamName: data.teamName
      });
    },
    saveBattle(data) {
      return axios.post('/api/battle/legacy/save.php', data);
    },
    getLeaderboard(limit = 100, offset = 0) {
      return axios.get(`/api/leaderboard/legacy/get.php?limit=${limit}&offset=${offset}`);
    },
    getBattleHistory(userId, limit = 20, offset = 0) {
      return axios.get(`/api/battle/legacy/history.php?userId=${userId}&limit=${limit}&offset=${offset}`);
    },
    challengeStreamer(data) {
      return axios.post('/api/battle/legacy/streamer-challenge.php', {
        streamer1TwitchId: data.streamer1TwitchId,
        streamer1TwitchDisplayName: data.streamer1TwitchDisplayName,
        streamer2TwitchDisplayName: data.streamer2TwitchDisplayName,
        channelId: data.channelId,
        teamName: data.teamName,
        faction: data.faction
      });
    },
    acceptStreamer(data) {
      return axios.post('/api/battle/legacy/streamer-accept.php', {
        streamer2TwitchId: data.streamer2TwitchId,
        streamer1TwitchDisplayName: data.streamer1TwitchDisplayName,
        streamer2TwitchDisplayName: data.streamer2TwitchDisplayName,
        channelId: data.channelId,
        teamName: data.teamName,
        faction: data.faction
      });
    },
    // Team Battle Methods
    createTeamChallenge(data) {
      return axios.post('/api/battle/legacy/team/challenge.php', {
        team1QueueId: data.team1QueueId,
        team2QueueId: data.team2QueueId,
        channelId: data.channelId,
        battleType: data.battleType
      });
    },
    acceptTeamChallenge(data) {
      return axios.post('/api/battle/legacy/team/accept.php', {
        battleId: data.battleId
      });
    },
    saveTeamBattle(data) {
      return axios.post('/api/battle/legacy/team/save.php', {
        battleId: data.battleId,
        winnerTeamName: data.winnerTeamName,
        team1Cards: data.team1Cards,
        team2Cards: data.team2Cards
      });
    },
    getTeamLeaderboard(battleType = '2v2', limit = 100, offset = 0) {
      return axios.get(`/api/leaderboard/legacy/team.php?t=${battleType}&limit=${limit}&offset=${offset}`);
    }
  };
})();
